import { Grid } from "@material-ui/core";
import { Box, FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Skeleton, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { AppSelect, SelectRadioInput } from "./ProviderInputComponents";
import useStyles from "./Common.style";
import { obesityMedications, typeOfPreviousSurgery } from '../../../data/db'
import { RepLIProviderTextField } from "../../../components";
import mainTheme from "../../../themes/mainTheme";

const Bariatrics = (props) => {
    const classes = useStyles();
    const skeletonHeight = 50;
    const [autoUpdate, setAutoUpdate] = useState(false);


    useEffect(() => {
        props.validator.purgeFields();
        setAutoUpdate(!autoUpdate);
    }, [
        props.hereForBariatricCare,
        props.hereForBariatricsOrWeightManagement,
        props.currentWeight,
        props.desiredWeightPriorToPregnency,
        props.bariatricSurgeryPlanning,
        props.typeOfPreviousSurgery,
        props.dateOfPreviousSurgery,
        props.previousStaringWeight,
        props.previousCurrentWeight,
        props.previousDesiredWeight,
        props.meetingVitaminGoals,
        props.desireBariatricSurgery,
        props.currentlyEnrolled,
        props.futureCurrentWeight,
        props.futureDesiredWeight,
        props.submitted,
    ]);

    return (
        <>
            <Grid container style={{ width: '100%' }}>
                <Typography variant="h5" style={{ paddingBottom: '10px' }}>
                Bariatric Care
                </Typography>
                <Grid item xs={12}>
                    {/* Bariatric care */}
                    <Typography gutterBottom>Are you here due to Bariatric Care?*</Typography>
                    <FormControl
                        component="fieldset"
                        error={props.submitted && !props.validator.fieldValid('hereForBariatricCare')}
                    >
                        <RadioGroup row
                            aria-label="Bariatric care"
                            value={props.hereForBariatricCare}
                            onChange={props.setHereForBariatricCare}
                        >
                            {["Yes", "No", "Unsure"].map((answer, i) =>
                                <FormControlLabel key={i} value={answer} control={<Radio  sx={{        
                                    '&.Mui-checked': {
                                      color: mainTheme.palette.primary.main,
                                    },
                                  }}  color="primary" />} label={answer} />
                            )}
                        </RadioGroup>
                        <FormHelperText>
                            {props.validator.message('hereForBariatricCare', props.hereForBariatricCare, 'required')}
                        </FormHelperText>
                    </FormControl>
                </Grid>
                { props.hereForBariatricCare && props.hereForBariatricCare ==='Yes' &&
                    <Grid container xs={12}>
                    <Grid item xs={12} style={{ marginBottom: 10 }}>
                        <Typography style={{ marginBottom: 10 }} gutterBottom>
                            Are you here for a bariatric surgery or weight management?*
                        </Typography>
                        <SelectRadioInput
                            setValue={props.handleBariatricsOrWeightManagementChange}
                            value={props.hereForBariatricsOrWeightManagement}
                            elements={["Weight management", "Bariatric surgery"]}
                            clearValues={[]}
                            error={props.submitted && !props.validator.fieldValid("hereForBariatricsOrWeightManagement")}
                        />
                        <FormHelperText style={{ color: 'red' }}>
                            {props.submitted && props.validator.message(
                                "hereForBariatricsOrWeightManagement",
                                props.hereForBariatricsOrWeightManagement,
                                "required"
                            )}
                        </FormHelperText>
                    </Grid>
                    {props.hereForBariatricsOrWeightManagement && props.hereForBariatricsOrWeightManagement === "Weight management" &&

                        <Box container style={{ width: "100%" }}>
                            <Grid item xl={12} md={12} className={classes.appSelectGridItem}>
                                <Typography>
                                    What obesity management medications are you currently taking ?*
                                </Typography>
                                <AppSelect
                                    style={{ marginTop: "15px" }}
                                    id={obesityMedications}
                                    value={props.whatObesityMedicationsTaking}
                                    label="Obesity Management Medications*"
                                    items={[...obesityMedications]}
                                    onChange={(e) => props.setWhatObesityMedicationsTaking(e.target.value)}
                                    fullWidth
                                    error={props.submitted && !props.validator.fieldValid(`whatObesityMedicationsTaking`)}
                                    helperText={props.validator.message(`whatObesityMedicationsTaking`, props.whatObesityMedicationsTaking, 'required')}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ margin: "10px 0" }}>
                                {props.loading ? (
                                    <Skeleton height={skeletonHeight} />
                                ) : (
                                    <>
                                        <Typography gutterBottom>
                                            What is your current weight ?
                                        </Typography>

                                        <TextField
                                            style={{ margin: '10px 0' }}
                                            type='number'
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: mainTheme.palette.primary.main, // Change the border color when focused
                                                    }
                                                },
                                                "& label.Mui-focused": {
                                                    color: mainTheme.palette.primary.main, // Change label color when focused
                                                }
                                            }}
                                            value={props.currentWeight}
                                            onChange={props.onCurrentWeightChange}
                                            inputProps={{ min: "1", step: "any", pattern: "[0-9]*" }}
                                            onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"].includes(e.key)) {
                                                    e.preventDefault(); // prevent non-numeric characters
                                                }
                                            }}
                                            label='Current Weight in lbs'
                                            fullWidth
                                            error={props.submitted && !props.validator.fieldValid(`currentWeight`)}
                                            helperText={props.validator.message(`currentWeight`, props.currentWeight, `currentWeight:${props.hereForBariatricsOrWeightManagement}`)}
                                        />

                                    </>
                                )}
                            </Grid>
                            <Grid item xs={12} style={{ margin: "10px 0" }}>
                                {props.loading ? (
                                    <Skeleton height={skeletonHeight} />
                                ) : (
                                    <>
                                        <Typography gutterBottom>
                                            What is your desired weight prior to pregnency ?
                                        </Typography>
                                        <TextField
                                            style={{ margin: '10px 0' }}
                                            type='number'
                                            value={props.desiredWeightPriorToPregnency}
                                            onChange={props.onDesiredWeightPriorToPregnencyChange}
                                            inputProps={{ min: "1", step: "any", pattern: "[0-9]*" }}
                                            onKeyDown={(e) => {
                                                if (["e", "E", "+", "-"].includes(e.key)) {
                                                    e.preventDefault(); // prevent non-numeric characters
                                                }
                                            }}
                                            label='Desired Weight in lbs'
                                            fullWidth
                                            error={props.submitted && !props.validator.fieldValid(`desiredWeightPriorToPregnency`)}
                                            helperText={props.validator.message(`desiredWeightPriorToPregnency`, props.desiredWeightPriorToPregnency, `currentWeight:${props.hereForBariatricsOrWeightManagement}`)}
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: mainTheme.palette.primary.main, // Change the border color when focused
                                                    }
                                                },
                                                "& label.Mui-focused": {
                                                    color: mainTheme.palette.primary.main, // Change label color when focused
                                                }
                                            }}
                                        />
                                    </>
                                )}
                            </Grid>
                        </Box>
                    }
                    {props.hereForBariatricsOrWeightManagement && props.hereForBariatricsOrWeightManagement === "Bariatric surgery" &&
                        <Box container style={{ width: "100%" }}>
                            <Grid item xs={12} style={{ marginBottom: 10 }}>
                                <Typography style={{ marginBottom: 10 }} gutterBottom>
                                    Have you had previous bariatric surgery or are you planning surgery in the future ?
                                </Typography>
                                <SelectRadioInput
                                    setValue={props.handleBariatricSurgeryPlanningChange} // Changed to appropriate prop
                                    value={props.bariatricSurgeryPlanning} // Changed to appropriate prop
                                    elements={["Previous surgery", "Future surgery"]} // Updated options
                                    clearValues={[]}
                                    error={props.submitted && !props.validator.fieldValid("bariatricSurgeryPlanning")}
                                />
                                <FormHelperText style={{ color: 'red' }}>
                                    {props.submitted && props.validator.message(
                                        "bariatricSurgeryPlanning",
                                        props.bariatricSurgeryPlanning,
                                        "required"
                                    )}
                                </FormHelperText>
                            </Grid>
                            {props.bariatricSurgeryPlanning && props.bariatricSurgeryPlanning === "Previous surgery" &&
                                <Box container style={{ width: "100%" }}>

                                    <Grid item xl={12} md={12} className={classes.appSelectGridItem}>
                                        <Typography>
                                            What type of surgery ?*
                                        </Typography>
                                        <AppSelect
                                            style={{ marginTop: "15px" }}
                                            id={typeOfPreviousSurgery}
                                            value={props.typeOfPreviousSurgery}
                                            label="Type of surgery*"
                                            items={[...typeOfPreviousSurgery, 'Other']}
                                            onChange={(e) => props.setTypeOfPreviousSurgery(e.target.value)}
                                            fullWidth
                                            error={props.submitted && !props.validator.fieldValid(`typeOfPreviousSurgery`)}
                                            helperText={props.validator.message(`typeOfPreviousSurgery`, props.typeOfPreviousSurgery, 'required')}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        {props.loading ? (
                                            <Skeleton height={skeletonHeight} />
                                        ) : (
                                            <>
                                                <Typography style={{ marginTop: "10px" }}>
                                                    Date Of Surgery?*
                                                </Typography>
                                                <RepLIProviderTextField
                                                    label={`Date of surgery*`}
                                                    type="date"
                                                    InputLabelProps={{ shrink: true }}
                                                    error={
                                                        props.submitted && !props.validator.fieldValid("dateOfPreviousSurgery")
                                                    }
                                                    helperText={props.validator.message(
                                                        "dateOfPreviousSurgery",
                                                        props.dateOfPreviousSurgery,
                                                        "required"
                                                    )}
                                                    onChange={props.onDateOfPreviousSurgeryChange}
                                                    value={props.dateOfPreviousSurgery}
                                                    inputProps={{
                                                        max: new Date().toISOString().split("T")[0]
                                                    }}
                                                />
                                                <Grid item xs={12} style={{ margin: "10px 0" }}>
                                                    {props.loading ? (
                                                        <Skeleton height={skeletonHeight} />
                                                    ) : (
                                                        <>
                                                            <Typography gutterBottom >
                                                                Starting Weight
                                                            </Typography>


                                                            <TextField
                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "&.Mui-focused fieldset": {
                                                                            borderColor: mainTheme.palette.primary.main, // Change the border color when focused
                                                                        }
                                                                    },
                                                                    "& label.Mui-focused": {
                                                                        color: mainTheme.palette.primary.main, // Change label color when focused
                                                                    }
                                                                }}
                                                                style={{ margin: '10px 0' }}
                                                                type='number'
                                                                value={props.previousStaringWeight}
                                                                onChange={props.onPreviousStaringWeightChange}
                                                                inputProps={{ min: "1", step: "any", pattern: "[0-9]*" }}
                                                                onKeyDown={(e) => {
                                                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                                                        e.preventDefault(); // prevent non-numeric characters
                                                                    }
                                                                }}
                                                                label='Starting Weight in lbs'
                                                                fullWidth
                                                                error={props.submitted && !props.validator.fieldValid(`previousStaringWeight`)}
                                                                helperText={props.validator.message(`previousStaringWeight`, props.previousStaringWeight, `previousStaringWeight:${props.bariatricSurgeryPlanning}`)}
                                                            />

                                                        </>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} style={{ margin: "10px 0" }}>
                                                    {props.loading ? (
                                                        <Skeleton height={skeletonHeight} />
                                                    ) : (
                                                        <>
                                                            <Typography gutterBottom >
                                                                Current Weight
                                                            </Typography>
                                                            <TextField
                                                                style={{ margin: '10px 0' }}
                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "&.Mui-focused fieldset": {
                                                                            borderColor: mainTheme.palette.primary.main, // Change the border color when focused
                                                                        }
                                                                    },
                                                                    "& label.Mui-focused": {
                                                                        color: mainTheme.palette.primary.main, // Change label color when focused
                                                                    }
                                                                }}
                                                                type='number'
                                                                value={props.previousCurrentWeight}
                                                                onChange={props.onPreviousCurrentWeightChange}
                                                                inputProps={{ min: "1", step: "any", pattern: "[0-9]*" }}
                                                                onKeyDown={(e) => {
                                                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                                                        e.preventDefault(); // prevent non-numeric characters
                                                                    }
                                                                }}
                                                                label='Current Weight in lbs'
                                                                fullWidth
                                                                error={props.submitted && !props.validator.fieldValid(`previousCurrentWeight`)}
                                                                helperText={props.validator.message(`previousCurrentWeight`, props.previousCurrentWeight, `previousCurrentWeight:${props.bariatricSurgeryPlanning}`)}
                                                            />
                                                        </>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12} style={{ margin: "10px 0" }}>
                                                    {props.loading ? (
                                                        <Skeleton height={skeletonHeight} />
                                                    ) : (
                                                        <>
                                                            <Typography gutterBottom >
                                                                Desired Weight prior to pregnency
                                                            </Typography>

                                                            <TextField
                                                                sx={{
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "&.Mui-focused fieldset": {
                                                                            borderColor: mainTheme.palette.primary.main,
                                                                        }
                                                                    },
                                                                    "& label.Mui-focused": {
                                                                        color: mainTheme.palette.primary.main,
                                                                    }
                                                                }}
                                                                style={{ margin: '10px 0' }}
                                                                type='number'
                                                                value={props.previousDesiredWeight}
                                                                onChange={props.onPreviousDesiredWeightChange}
                                                                inputProps={{ min: "1", step: "any", pattern: "[0-9]*" }}
                                                                onKeyDown={(e) => {
                                                                    if (["e", "E", "+", "-"].includes(e.key)) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                                label='Desired Weight in lbs'
                                                                fullWidth
                                                                error={props.submitted && !props.validator.fieldValid(`previousDesiredWeight`)}
                                                                helperText={props.validator.message(`previousDesiredWeight`, props.previousDesiredWeight, `previousDesiredWeight:${props.bariatricSurgeryPlanning}`)}
                                                            />
                                                        </>
                                                    )}
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography gutterBottom>{`Are you meeting your post-bariatric nutrition and vitamin goals ?*`}</Typography>
                                                    <FormControl
                                                        component="fieldset"
                                                        error={props.submitted && !props.validator.fieldValid('meetingVitaminGoals')}
                                                    >

                                                        <RadioGroup row
                                                            aria-label="post-bariatric nutrition and vitamin goals"
                                                            value={props.meetingVitaminGoals}
                                                            onChange={e => props.setMeetingVitaminGoals(e.target.value)}
                                                        >
                                                            {["Yes", "No"].map((answer, i) =>
                                                                <FormControlLabel key={i} value={answer} control={<Radio sx={{
                                                                    '&.Mui-checked': {
                                                                        color: "#1AA29D",
                                                                    },
                                                                }} color="primary" />} label={answer} />
                                                            )}
                                                        </RadioGroup>
                                                        <FormHelperText>
                                                            {props.validator.message('meetingVitaminGoals', props.meetingVitaminGoals, 'required')}
                                                        </FormHelperText>
                                                    </FormControl>
                                                </Grid>
                                            </>

                                        )}
                                    </Grid>
                                </Box>

                            }
                            {
                                props.bariatricSurgeryPlanning && props.bariatricSurgeryPlanning === "Future surgery" &&
                                <Box container style={{ width: "100%" }}>
                                    <Grid item xs={12}>
                                        <Typography gutterBottom>{`Do you desire bariatric surgery in future ?*`}</Typography>
                                        <FormControl
                                            component="fieldset"
                                            error={props.submitted && !props.validator.fieldValid('desireBariatricSurgery')}
                                        >

                                            <RadioGroup row
                                                aria-label="post-bariatric nutrition and vitamin goals"
                                                value={props.desireBariatricSurgery}
                                                onChange={e => props.setDesireBariatricSurgery(e.target.value)}
                                            >
                                                {["Yes", "No"].map((answer, i) =>
                                                    <FormControlLabel key={i} value={answer} control={<Radio sx={{
                                                        '&.Mui-checked': {
                                                            color: "#1AA29D",
                                                        },
                                                    }} color="primary" />} label={answer} />
                                                )}
                                            </RadioGroup>
                                            <FormHelperText>
                                                {props.validator.message('desireBariatricSurgery', props.desireBariatricSurgery, 'required')}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography gutterBottom>{`Are you currently enrolled in a program?*`}</Typography>
                                        <FormControl
                                            component="fieldset"
                                            error={props.submitted && !props.validator.fieldValid('currentlyEnrolled')}
                                        >

                                            <RadioGroup row
                                                aria-label="currently enrolled in a program"
                                                value={props.currentlyEnrolled}
                                                onChange={e => props.setCurrentlyEnrolled(e.target.value)}
                                            >
                                                {["Yes", "No"].map((answer, i) =>
                                                    <FormControlLabel key={i} value={answer} control={<Radio sx={{
                                                        '&.Mui-checked': {
                                                            color: "#1AA29D",
                                                        },
                                                    }} color="primary" />} label={answer} />
                                                )}
                                            </RadioGroup>
                                            <FormHelperText>
                                                {props.validator.message('currentlyEnrolled', props.currentlyEnrolled, 'required')}
                                            </FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} style={{ margin: "10px 0" }}>
                                        {props.loading ? (
                                            <Skeleton height={skeletonHeight} />
                                        ) : (
                                            <>
                                                <Typography gutterBottom >
                                                    Current Weight
                                                </Typography>

                                                <TextField
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: mainTheme.palette.primary.main, // Change the border color when focused
                                                            }
                                                        },
                                                        "& label.Mui-focused": {
                                                            color: mainTheme.palette.primary.main, // Change label color when focused
                                                        }
                                                    }}
                                                    style={{ margin: '10px 0' }}
                                                    type='number'
                                                    value={props.futureCurrentWeight}
                                                    onChange={props.onFutureCurrentWeightChange}
                                                    inputProps={{ min: "1", step: "any", pattern: "[0-9]*" }}
                                                    onKeyDown={(e) => {
                                                        if (["e", "E", "+", "-"].includes(e.key)) {
                                                            e.preventDefault(); // prevent non-numeric characters
                                                        }
                                                    }}
                                                    label='Current Weight in lbs'
                                                    fullWidth
                                                    error={props.submitted && !props.validator.fieldValid(`futureCurrentWeight`)}
                                                    helperText={props.validator.message(`futureCurrentWeight`, props.futureCurrentWeight, `futureCurrentWeight:${props.bariatricSurgeryPlanning}`)}
                                                />
                                            </>
                                        )}
                                    </Grid>
                                    <Grid item xs={12} style={{ margin: "10px 0" }}>
                                        {props.loading ? (
                                            <Skeleton height={skeletonHeight} />
                                        ) : (
                                            <>
                                                <Typography gutterBottom >
                                                    Desired Weight prior to pregnency
                                                </Typography>

                                                <TextField
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            "&.Mui-focused fieldset": {
                                                                borderColor: mainTheme.palette.primary.main, // Change the border color when focused
                                                            }
                                                        },
                                                        "& label.Mui-focused": {
                                                            color: mainTheme.palette.primary.main, // Change label color when focused
                                                        }
                                                    }}
                                                    style={{ margin: '10px 0' }}
                                                    type='number'
                                                    value={props.futureDesiredWeight}
                                                    onChange={props.onFutureDesiredWeightChange}
                                                    inputProps={{ min: "1", step: "any", pattern: "[0-9]*" }}
                                                    onKeyDown={(e) => {
                                                        if (["e", "E", "+", "-"].includes(e.key)) {
                                                            e.preventDefault(); // prevent non-numeric characters
                                                        }
                                                    }}
                                                    label='Desired Weight in lbs'
                                                    fullWidth
                                                    error={props.submitted && !props.validator.fieldValid(`futureDesiredWeight`)}
                                                    helperText={props.validator.message(`futureDesiredWeight`, props.futureDesiredWeight, `futureDesiredWeight:${props.bariatricSurgeryPlanning}`)}
                                                />
                                            </>
                                        )}
                                    </Grid>
                                </Box>
                            }

                        </Box>
                    }



                </Grid>}
            </Grid>
        </>
    );
};

export default Bariatrics;
